import { publicApi } from 'api/public/api';
import { API } from 'shared/constants/api';
import type { PromoCode, PromoCodeArgs, User } from './types';

export const USER_API_REDUCER_KEY = 'userApi';

export const userApi = publicApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserProfile: builder.query<User, { token: string | null }>({
      query: ({ token }) => ({
        url: API.user.profile,
        params: { token },
      }),
    }),
    getPromoCodes: builder.query<
      PromoCode[],
      PromoCodeArgs & { token: string | null }
    >({
      query: (params) => ({
        url: API.user.get_promo_codes,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({
                type: 'PromoCodes' as const,
                _id,
              })),
              { type: 'PromoCodes', _id: 'LIST' },
            ]
          : [{ type: 'PromoCodes', _id: 'LIST' }],
    }),
  }),
});

export const { useGetUserProfileQuery, useGetPromoCodesQuery } = userApi;
